module.exports = [   
    {
      id: "advisorOwner",
      fieldName: "Advisor Owner",
    },
    {
      id: "email",
      fieldName: "Email",
    },
    {
      id: "lastName",
      fieldName: "Last Name",
    },
    {
      id: "mobile",
      fieldName: "Mobile",
    },
]